import { render, staticRenderFns } from "./DissertationCard.vue?vue&type=template&id=6a290152&scoped=true"
import script from "./DissertationCard.vue?vue&type=script&lang=js"
export * from "./DissertationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a290152",
  null
  
)

export default component.exports